import React from "react";
import { Card, Row, Col } from "antd";
import {
  FileTextOutlined,
  CheckSquareOutlined,
  FileAddOutlined,
  EditOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import "./index.css";

const data = [
  { icon: <FileTextOutlined />, count: "24,650", label: "Total Cases" },
  { icon: <CheckSquareOutlined />, count: "24,650", label: "Closed Cases" },
  { icon: <FileAddOutlined />, count: "24,650", label: "New Cases" },
  { icon: <EditOutlined />, count: "24,650", label: "In Progress Cases" },
  { icon: <CalendarOutlined />, count: "24,650", label: "Scheduled Cases" },
];

const CaseCards: React.FC = () => {
  return (
    <Row
      justify="center"
      gutter={[0, 16]}
      style={{
        display: "flex",
        flexWrap: "nowrap",
      }}
      className="case-cards-container"
    >
      {data.map((item, index) => (
        <Col
          key={index}
          flex="1"
          className="case-card-col"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            className="case-card"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              maxHeight: 90,
              borderRadius:
                index === 0
                  ? "12px 0px 0px 12px"
                  : index === data.length - 1
                  ? "0px 12px 12px 0px"
                  : "0px",
            }}
          >
            <Row align="middle" style={{ width: "100%", whiteSpace: "nowrap" }}>
              <Col
                flex="none"
                style={{ textAlign: "center", marginRight: "12px" }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: "#f5f8fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ fontSize: "26px", color: "#1e4d6b" }}>
                    {item.icon}
                  </div>
                </div>
              </Col>

              <Col flex="auto">
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#0E445D",
                  }}
                >
                  {item.count}
                </div>
                <div style={{ fontSize: "12px", color: "#0F1727" }}>
                  {item.label}
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default CaseCards;
